import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';

import { MDBModalRef } from '../../../app/shared/services/mdb-modal-stub.service';
import { Enums } from '../../shared/models/enums';
import { CellRendererElementSubTypes } from '../../shared/widgets/data-grid/enums/cell-renderer-element-Subtype.enum';
import { CellRendererElementTypes } from '../../shared/widgets/data-grid/enums/cell-renderer-element.enum';
import { CellRendererTypes } from '../../shared/widgets/data-grid/enums/cell-renderer.enum';
import { FilterTypes } from '../../shared/widgets/data-grid/enums/filter-types.enum';
import { TableColumn } from '../../shared/widgets/data-grid/interfaces/table-column.interface';

@Injectable()
export class CertificationTrackerGridService {
    modalRef: MDBModalRef;
    confirmationStatus = Enums.confirmationStatus;
    // TODO:- Need to move to constant and dashboard grid service level
    cols: Array<TableColumn> = [
        {
            field: 'projectName',
            header: 'Project Name',
            pinned: false,
            sort: true,
            sortName: 'projectName',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'masterArea',
            header: 'Project Floor Area(m²)',
            pinned: false,
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.fixedTo2Decimal
            }
        },
        {
            field: 'subprojectName',
            header: 'Subproject Name',
            sort: true,
            sortName: 'subprojectName',
            filter: { type: FilterTypes.text },
            cellRenderer: {
                type: CellRendererTypes.eventHtml,
                elementType: CellRendererElementTypes.anchor,
                eventName: 'onSubprojectNameClick',
                renderHtml: this.subprojectNameRenderer
            }
        },
        {
            field: 'projectNumber',
            header: 'Project Number',
            translationKey: 'ProjNumber',
            sortName: 'projectNumber',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'fileNumber',
            header: 'File Number',
            translationKey: 'FileNumber',
            sortName: 'fileNumber',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'country',
            header: 'Country',
            sort: true,
            sortName: 'country',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'city',
            header: 'City',
            sort: true,
            sortName: 'city',
            filter: { type: FilterTypes.text }
        },
        
        {
            field: 'toolName',
            header: 'Building Type',
            sort: true,
            sortName: 'buildingType',
            filter: {
                type: FilterTypes.select, selectOptions: [
                    { label: 'All', value: '' },
                    { label: 'Homes', value: 'Homes' },
                    { label: 'Apartments', value: 'Apartments' },
                    { label: 'Hotel', value: 'Hotel' },
                    { label: 'Resort', value: 'Resort' },
                    { label: 'Serviced Apartment', value: 'Serviced Apartment' },
                    { label: 'Retail', value: 'Retail' },
                    { label: 'Industrial', value: 'Industrial' },
                    { label: 'Office', value: 'Office' },
                    { label: 'Healthcare', value: 'Healthcare' },  
                    { label: 'Education', value: 'Education' },
                    { label: 'Mixed Use', value: 'Mixed Use' }
                ]
            },
        },
        
        {
            field: 'partner',
            header: 'Certifier',
            sort: true,
            sortName: 'partner',
            filter: { type: FilterTypes.text },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.certifierCellRenderer
            }
        },
        {
            field: 'auditor',
            header: 'Auditor',
            filter: { type: FilterTypes.text },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.auditorCellRenderer
            }
        },
        {
            field: 'auditCycleFinal',
            header: 'Audit Cycle',
            //cellRenderer: {
            //    type: CellRendererTypes.html,
            //    renderHtml: this.dateCellRenderer
            //}
            //filter: { type: FilterTypes.text }
        },
        
        {
            field: 'reviewer',
            header: 'Reviewer',
            sortName: 'reviewer',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'reviewCycleFinal',
            header: 'Review Cycle',
            //cellRenderer: {
            //    type: CellRendererTypes.html,
            //    renderHtml: this.dateCellRenderer
            //}
            //filter: { type: FilterTypes.text }
        },
        {
            field: 'energy',
            header: 'Energy',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.savingsCellRenderer
            }
        },
        {
            field: 'water',
            header: 'Water',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.savingsCellRenderer
            }
        },
        {
            field: 'material',
            header: 'Material',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.savingsCellRenderer
            }
        },
        {
            field: 'energySavingsPerYear',
            header: 'Energy Savings(MWh/Year)',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.fixedTo2Decimal
            }
        },
        {
            field: 'waterSavingsPerYear',
            header: 'Water Savings(m³/Year)',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.fixedTo2Decimal
            }
        }, ,
        {
            field: 'embodiedEnergyMaterialSavings',
            header: 'Embodied Energy in Material Savings(GJ)',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.fixedTo2Decimal
            }
        },
        {
            field: 'embodiedCarbonMaterialSavings',
            header: 'Embodied Carbon in Materials Savings(tCO2e)',
            translationKey: 'EmbodiedCarbon',
            sortName: 'EmbodiedCarbon',
            filter: { type: FilterTypes.text },
            sort: true,
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.fixedTo2Decimal
            }
        },
        {
            field: 'cO2SavingsPerYear',
            header: 'CO2 Savings(tCO2/Year)',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.fixedTo2Decimal
            }
        },
        {
            field: 'floorSpaceCertified',
            header: 'Subproject Floor Space(m²)',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.fixedTo2Decimal
            }
        },
        {
            field: 'onlineOffline',
            header: 'Online/Offline',
            filter: {
                type: FilterTypes.select, selectOptions: [
                    { label: 'All', value: '' },
                    { label: 'Online', value: 'Online' },
                    { label: 'Offline', value: 'Offline' }
                ]
            }
        },
         {
            field: 'peopleImpactCount',
            header: 'No. of People Impacted',
            translationKey: 'PeopleImpactCount',
            // sort: true,
            pinned: false,
            sortName: 'PeopleImpactCount',
            // filter: { type: FilterTypes.text }
        },
        {
            field: 'totalNoOfUnits',
            header: 'No. of Home Units',
            translationKey: 'NoOfHomeUnits',
            sort: true,
            pinned: false,
            sortName: 'totalNoOfUnits',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'sentForReg',
            header: 'Sent for Registration',
            sort: true,
            sortName: 'sentForReg',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'regAccepted',
            header: 'Registration Accepted',
            sort: true,
            sortName: 'regAccepted',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'audSelected',
            header: 'Auditor Selected',
            sort: true,
            sortName: 'audSelected',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'sentForAudit',
            header: 'Sent for Audit',
            sort: true,
            sortName: 'sentForAudit',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'sentForReview',
            header: 'Sent for Review',
            sort: true,
            sortName: 'sentForReview',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'auditFeedback',
            header: 'Auditor Feedback',
            sort: true,
            sortName: 'auditFeedback',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'reviewFeedback',
            header: 'Reviewer Feedback',
            sort: true,
            sortName: 'reviewFeedback',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'certified',
            header: 'Subproject Certified',
            sort: true,
            sortName: 'certified',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'projectCertified',
            header: 'Certificate Issued',
            sort: true,
            sortName: 'projectCertified',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'overAllProgress',
            header: 'Overall Progress',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.progressCellRenderer
            }
        },
        {
            field: 'regProgress',
            header: 'Project Registration',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.progressCellRenderer
            }
        },
        {
            field: 'preCertProgress',
            header: 'Preliminary Certificate',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.progressCellRenderer
            }
        },
        {
            field: 'edgeCertProgress',
            header: 'EDGE Certification',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.progressCellRenderer
            }
        },
        
        {
            field: 'showPreCertDownload',
            header: 'Download Pre Certificate',
            isEnable: 'showPreCertDownload',
            displayName: ' ',
            cellRenderer: {
                type: CellRendererTypes.event,
                elementType: CellRendererElementTypes.anchor,
                eventName: 'onDownloadPreCertificate',
                elementsubType: CellRendererElementSubTypes.download,
            }
        },
        {
            field: 'showPostCertDownload',
            header: 'Download Post Certificate',
            isEnable: 'showPostCertDownload',
            displayName: ' ',
            cellRenderer: {
                type: CellRendererTypes.event,
                elementType: CellRendererElementTypes.anchor,
                eventName: 'onDownloadPostCertificate',
                elementsubType: CellRendererElementSubTypes.download,
            }
        },
        {
            field: 'dateOfExpiryPreZC',
            header: 'Preliminary ZC Certificate Expiry Date',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'dateOfExpiryFinalZC',
            header: 'Final ZC Certificate Expiry Date',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            },


        },
        
        {
            field: 'dateOfExpiryPreZCR',
            header: 'Preliminary ZC Renewal Certificate Expiry Date',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'dateOfExpiryFinalZCR',
            header: 'Final ZC Renewal Certificate Expiry Date',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
    ];

    constructor() { }

    dateCellRenderer(rowData: any, field: any) {
        if (rowData[field]) {
            const value = formatDate(rowData[field], 'yyyy-MM-dd hh:mm a', 'en-US');
            return `<div class="text-truncate" title="` + value + `">` + value + `</div>`;
        } else {
            return '';
        }
    }

    fixedTo2Decimal(rowData: any, field: any) {
        if (rowData[field]) {
            const value = parseFloat(rowData[field]);
            return (!Number.isNaN(value)) ? `<span class="text-truncate"
            title="${Number(value.toFixed(2)).toLocaleString()}">${Number(value.toFixed(2)).toLocaleString()}</span>` : rowData[field];
        } else {
            return '';
        }
    }

    savingsCellRenderer(rowData: any, field: any) {
        if (rowData[field]) {
            const percent = parseFloat(rowData[field].replace('%', ''));
            if (!Number.isNaN(percent) && percent >= 20) {
                return `<div class="text-green text-truncate" title="` + rowData[field] + `">` + rowData[field] + `</div>`;
            } else {
                return rowData[field];
            }
        } else {
            return '';
        }
    }

    subprojectNameRenderer(rowData: any, field: any) {
        if (rowData.onlineOffline === 'Online') {
            return `<span>${rowData[field]}</span>`;
        } else {
            return `<span class="grid-cell-notification me-1"><i class="fas fa-circle grey-muted"></i></span>${rowData[field]}`;
        }
    }

    auditorCellRenderer(rowData: any) {
        if (rowData.audAccepted === true && rowData.auditor) {
            return `<div class="text-truncate"><i class="fas fa-check text-green me-1" title="Accepted">
            </i><span title="${rowData.auditor}">${rowData.auditor}</span></div>`;
        } else if (rowData.audAccepted === null && rowData.auditor) {
            return `<div class="text-truncate"><i class="fas fa-exclamation-triangle text-yelloworange me-1" title="Action Pending">
            </i><span title="${rowData.auditorName}">${rowData.auditorName}</span></div>`;
        } else {
            return '';
        }
    }

    certifierCellRenderer(rowData: any) {
        if (rowData.partAccepted === true) {
            return `<div class="text-truncate"><i class="fas fa-check text-green me-1" title="Accepted">
            </i><span title="${rowData.partner}">${rowData.partner}</span></div>`;
        } else {
            return `<div class="text-truncate"><i class="fas fa-exclamation-triangle text-yelloworange me-1" title="Action Pending">
            </i><span title="${rowData.partner}">${rowData.partner}</span></div>`;
        }
    }

    progressCellRenderer(rowData: any, field: any) {
        const value = rowData[field];
        let color = '';
        switch (value) {
            case 25:
                color = '#9e9e9e';
                break;
            case 50:
                color = '#f0ad4e';
                break;
            case 75:
                color = '#369eff';
                break;
            default:
                color = '#61c250';
                break;
        }

        return `<div class="progressvalue">${value}%</div><div class="progress"><div class="progress-bar"
        style="width:${value}%; background-color:${color}"></div></div>`;
    }
}

